import { z } from 'zod';

export const vehiculeCheckEmailSchema = z.object({
  id: z.string().optional(),
  vehiculeCheckId: z.string().nullish(),
  fromName: z.string().nullish(),
  fromEmail: z.string().nullish(),
  replyToEmail: z.string().nullish(),
  toLastname: z.string().nullish(),
  toFirstname: z.string().nullish(),
  toEmail: z.string().nullish(),
  ccEmails: z.array(z.string()).nullish(),
  emailSubject: z.string().nullish(),
  emailContent: z.string().nullish(),
  sent: z.boolean().default(false),
  createdAt: z.string().nullish(),
});

export type TVehiculeCheckEmailSchema = z.infer<
  typeof vehiculeCheckEmailSchema
>;
